import { render, staticRenderFns } from "./workoutsDashboard.vue?vue&type=template&id=6c36fa0e"
import script from "./workoutsDashboard.vue?vue&type=script&lang=js"
export * from "./workoutsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports